import { render, staticRenderFns } from "./NavigationMenuForPC.vue?vue&type=template&id=48741850&scoped=true&"
import script from "./NavigationMenuForPC.vue?vue&type=script&lang=js&"
export * from "./NavigationMenuForPC.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMenuForPC.vue?vue&type=style&index=0&id=48741850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48741850",
  null
  
)

export default component.exports